export default {
  pages: {
    nasiyaInvoice: {
      banner: {
        title: 'Данные счёт-фактуры выставляются на платформе Didox',
      },
      header: {
        title: 'Создание счёт-фактуры',
      },
    },
  },
};
